// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CAR_DATA_MASTER_SEARCH_DATA_MASTER,
} from './constants';

export function searchDataMaster(args) {
  return {
    type: CAR_DATA_MASTER_SEARCH_DATA_MASTER,
    data: args
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_SEARCH_DATA_MASTER:
      return {
        ...state,
        searchData: action.data
      };

    default:
      return state;
  }
}
